module.exports = __webpack_public_path__ + "static/media/restaurant.4bb87cba.jpg";